import { apiRequest } from './apiClient.js';

export const trackingService = { lookup: (trackingNumber) => apiRequest(`/tracking/${encodeURIComponent(trackingNumber)}`) };